var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isBaseInput)?_c('base-input',{attrs:{"field":_vm.field}}):_vm._e(),(_vm.isPassportMRZ)?_c('passport-mrz-input',{attrs:{"field":_vm.field}}):_vm._e(),(_vm.isTd1MRZ)?_c('id-one-mrz-input',{attrs:{"field":_vm.field}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }